import { createContext } from 'react'

const NavContext = createContext({ navOpen: true })

export default NavContext
